"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceOnlineBadge = DeviceOnlineBadge;
var jsx_runtime_1 = require("react/jsx-runtime");
var table_1 = require("../../table");
// Online is set by the ingest functions and cleared after 30 minutes of silence; anything else counts as offline.
// Off means every data point was ignored on purpose, so it wins over online/offline.
function DeviceOnlineBadge(props) {
    var device = props.device;
    if (device.off) {
        return (0, jsx_runtime_1.jsx)(table_1.StatusBadge, { color: "amber", children: "Off" });
    }
    var isOnline = device.online === true;
    return (0, jsx_runtime_1.jsx)(table_1.StatusBadge, { color: isOnline ? "green-soft" : "gray", children: isOnline ? "Online" : "Offline" });
}
